const GOOGLE_CLIENT_ID = "569782359239-i592b87tpsr2oap9g95lmugo20ntqisl.apps.googleusercontent.com";

export function googleRedirectUri(): string {
  const base = import.meta.env.VITE_APP_ORIGIN ?? window.location.origin;
  return `${base}/verify`;
}

export function googleAuthUrl(): string {
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: googleRedirectUri(),
    response_type: "code",
    scope: "openid email profile",
    access_type: "offline",
    prompt: "select_account",
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${params}`;
}
